<template>
	<div v-if="!loading">
		<div v-if="showOnlyNextMatch" class="mb-6 xl:mb-4">
			<div class="uppercase bg-zt-light-full h-[38px] px-[14px] flex items-center border border-zt-light rounded-t-zt text-xs">
				Najbliższy bezpośredni mecz
			</div>
			<Transition name="fade" mode="out-in">
				<div v-if="nextMatch">
					<FootballStatsListItem class="border-t-0 rounded-b-zt" :show-hour="shouldShowHour(nextMatch)"
					                       show-league-name show-date :match="nextMatch" show-odds :redirect-to-h2h="nextMatch.is_h2h_available"/>
				</div>
				<div v-else class="h-[51px] text-xs grid place-items-center bg-zt-light/35 text-zt-more border-x border-b border-zt-light rounded-b-zt">
          Brak meczu do wyświetlania
				</div>
			</Transition>
		</div>
    <div v-if="!showOnlyNextMatch">
      <div class="uppercase bg-zt-light-full h-[38px] px-[14px] flex items-center border border-zt-light rounded-t-zt text-xs">
        Bezpośrednie mecze
      </div>
      <template v-if="matchesToShow.length > 0">
        <Transition name="fade" mode="out-in">
          <div>
            <Transition name="fade" mode="in-out">
              <div v-if="showHomeAway" class="flex justify-center border-b border-zt-light border-x border-x-zt-light border-t-zt-light text-xs font-medium
	                    text-zt-more py-2.5 bg-[#242e3d] px-2">
                <button :class="{ '!bg-zt-light text-white' : homeAway === 'all' }" @click="changeHomeAway('all')"
                        class="hover:bg-zt-light/35 transition-colors uppercase  h-[28px] w-[113px] border border-r-0
	                         border-zt-light rounded-l-[5px]">
                  Ogółem
                </button>
                <button :class="{ '!bg-zt-light text-white' : homeAway === 'home/away' }" @click="changeHomeAway('home/away')"
                        class="hover:bg-zt-light/35 transition-colors uppercase h-[28px] w-[113px] border rounded-r-zt border-zt-light">
                  Dom/Wyjazd
                </button>
              </div>
            </Transition>
            <div v-for="(match, index) in matchesToShow" :key="match.date">
              <FootballStatsListItem class="border-t-0"
                                     v-if="!statuses['live'].includes(match.status)" :show-relative-date="false"
                                     :class="{ 'rounded-b-zt' : matches.length <= amount && index === matches.length - 1 }"
                                     show-league-name show-date :match="match" :redirect-to-h2h="match.is_h2h_available"/>
            </div>
            <div v-if="matchesCount > amount" class="py-4 flex items-center rounded-b-zt border-b bg-zt-light/35 border-x border-zt-light justify-center text-zt-more text-xs underline font-normal uppercase">
              <span class="cursor-pointer zt-hover" @click="handleExpand">Rozwiń</span>
            </div>
          </div>
        </Transition>
      </template>
      <div v-else class="h-[50px] text-xs grid place-items-center bg-zt-light/35 text-zt-more border-x border-b border-zt-light rounded-b-zt">
        Brak meczów do wyświetlania
      </div>
    </div>
	</div>
</template>

<script>
import FootballStatsListItem from "../components/blocks/FootballStatsListItem.vue";
import football_mixin from "../mixins/football_mixin";
import {DateTime} from "luxon";
import utils_mixin from "../mixins/utils_mixin";
export default {
	name: 'FootballStatsDirectMatches',
	components: {FootballStatsListItem},
	inject: ['WP'],
  mixins: [football_mixin, utils_mixin],
	props: {
		teamA: {
			required: true,
		},
		teamB: {
			required: true
		},
    showOnlyNextMatch: {
      type: Boolean,
      default: false,
    },
		matches: Array,
	},
	data() {
		return {
			nextMatch: null,
			homeAway: 'all',
			amount: 3,
      statuses: {
        'live': ['1H', 'HT', '2H', 'ET', 'BT', 'P', 'LIVE'],
        'ended': ['FT', 'AET', 'PEN', 'CANC', 'ABD', 'AWD', 'WO'],
        'upcoming': ['TBD', 'NS', 'PST'],
      },
			showHomeAway: false,
      loading: true,
		}
	},
	computed: {
		matchesToShow() {
			if (this.homeAway === 'home/away') {
				return this.matches.filter(match => {
					return match.localteam_name === this.teamA.name && match.status !== 'PST'
				}).slice(0, this.amount);
			}
      let today = new Date();
			return this.matches.filter(match => {
        let matchDate = new Date(match.date);
        return match.status !== 'PST' || ( matchDate.getTime() > today.getTime() - 7 * 24 * 60 * 60 * 1000)
      }).slice(0, this.amount);
		},
		matchesCount() {
			if (this.homeAway === 'home/away') {
				return this.matches.filter(match => {
					return match.localteam_name === this.teamA.name
				}).length;
			}
			return this.matches.length;
		}
	},
	methods: {
		handleExpand() {
			this.amount += 5;
			countClicks('PORÓWNANIE DRUŻYN -> BEZPOŚREDNIE MECZE -> ROZWIŃ');
			this.showHomeAway = true;
		},
		changeHomeAway(value) {
			this.homeAway = value;
		},
		shouldShowHour(match) {
			const matchDate = DateTime.fromFormat(match.date, 'yyyy-MM-dd HH:mm:ss');
			const nextWeek = DateTime.now().startOf('day').plus({days: 7});

			const differenceInDays = nextWeek.diff(matchDate, 'days').days;

			return differenceInDays <= 7;
		},
    addWSListeners() {
      socket?.on('live-matches', data => {
        data.forEach(match => {
          if (this.nextMatch && match.match_id === this.nextMatch.match_id) {
            this.nextMatch.localteam_goals = match.localteam_goals;
            this.nextMatch.visitorteam_goals = match.visitorteam_goals;
            this.nextMatch.elapsed = match.elapsed;
            this.nextMatch.extra = match.extra;
            this.nextMatch.status = match.status;
            this.nextMatch.localteam_red_cards = match.localteam_red_cards;
            this.nextMatch.visitorteam_visitor_cards = match.visitorteam_visitor_cards;
          }
        })
      });
    }
	},
	mounted() {
		if (this.matches[0]['is_next_match']) {
			this.nextMatch = this.matches.shift();
      if((new Date(this.nextMatch.date)).setHours(0,0,0,0) === (new Date()).setHours(0,0,0,0)) {
        this.addWSListeners();
      }
		}
    this.loading = false;
	}
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;

}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>